import React from 'react';
import { motion } from 'framer-motion';
// Animasyon varyantlarını import ediyoruz
import { imageVariants, textVariants, containerVariants } from '../../script/animationVariants';
// useTranslation hook'unu import ediyoruz
import { useTranslation } from 'react-i18next';

const Section1 = () => {
  // t fonksiyonunu useTranslation ile alıyoruz.
  const { t } = useTranslation();

  return (
    <motion.div 
      className="col-start-3 col-span-10"
      initial="hidden" 
      whileInView="visible" 
      variants={containerVariants} // Container animasyon varyantı
    >
      {/* Şirket Profili Bölümü */}
      <motion.div 
        className="w-full grid grid-cols-1 md:grid-cols-2 mb-40" 
        variants={containerVariants}
      >
        <motion.div 
          className="space-y-10 mb-10" 
          variants={textVariants}
        >
          {/* Başlık: Çeviri dosyasından alınan metin */}
          <motion.h2 className="text-45 font-light">
            {t('section1.companyProfileTitle')}
          </motion.h2>


                      {/* Açıklama metni */}
                      <motion.p className="text-20 font-light" variants={textVariants}>
                        {t('about.slogan')}
                      </motion.p>
          
                      <motion.p className="text-20 font-light !mt-0" variants={textVariants}>
                        {t('about.paragraph1')}
                      </motion.p>
          
                      <motion.p className="text-20 font-light" variants={textVariants}>
                        {t('about.paragraph2')}
                      </motion.p>
          
                      <motion.p className="text-20 font-light" variants={textVariants}>
                        {t('about.paragraph3')}
                      </motion.p>
          
                      <motion.p className="text-20 font-light" variants={textVariants}>
                        {t('about.paragraph4')}
                      </motion.p>
        </motion.div>
        <motion.div className="min-h-40" variants={imageVariants}>
          {/* Resim veya diğer içerikler eklenebilir */}
        </motion.div>
      </motion.div>

      {/* Ömer Beyin Hikayesi Bölümü (yorum satırı halinde) */}
      {/*
      <motion.div 
        className="w-full grid grid-cols-1 md:grid-cols-2 mb-60" 
        variants={containerVariants}
      >
        <motion.div 
          className="space-y-10 mb-10" 
          variants={textVariants}
        >
          <motion.h2 className="text-45 font-light">
            {t('section1.omersStoryTitle')}
          </motion.h2>
          <motion.p className="text-20 font-light">
            {t('section1.omersStoryText')}
          </motion.p>
        </motion.div>
        <motion.div className="min-h-40" variants={imageVariants}>
          <img 
            src="/images/hakkimizda/hakkimizda-1.svg" 
            alt={t('section1.omersStoryAlt')}
          />
        </motion.div>
      </motion.div>
      */}
    </motion.div>
  );
};

export default Section1;
